// 3rd party imports
import * as React from 'react';
import { LocalizedText } from '@shared-ui/localization-context';
import { useStores } from 'hooks';
import { observer } from 'mobx-react';

// ui
import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkEmptyState } from 'uitk-react-empty-state';

// Utils
import { analyticsEvent } from '../util/analytics';

export const ErrorMessageExclusion = observer(() => {
  const { analytics, pzStore, userAuth } = useStores();

  React.useEffect(() => {
    if (pzStore?.pzPublisher?.network_status) {
      analyticsEvent(
        analytics,
        userAuth,
        pzStore,
        'affhub.error.exculsion.presented',
        'Affhub Error Exclusion Presented',
      );
    }
  }, [userAuth?.currentUserDetails, pzStore?.pzPublisher]);

  return (
    <UitkEmptyState fullscreen={true}>
      <UitkHeading size={3} tag="h2">
        <LocalizedText message="error.exclusion.heading" />
      </UitkHeading>
      <UitkSpacing margin="four">
        <UitkText size={300} theme="default">
          <LocalizedText message="error.exclusion.body.text" />
        </UitkText>
      </UitkSpacing>
    </UitkEmptyState>
  );
});
